exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".item-user-list td {\n  text-align: left;\n}\n\n.user-list-table .table{\n  margin-bottom: 0px;\n}\n\n.user-list-table .container {\n  position: unset !important;\n}\n\n.user-list-table .table td.td-20{\n  width: 20%;\n}\n\n.user-list-table .label-table{\n  margin-right: 15px;\n}\n\n.user-list-table .top-left-table-users-finals{\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  justify-items: center;\n}\n\n.group-button{\n  margin-left: 0px !important;\n}\n\n.btn-toolbar{\n  margin-left: 0px !important;\n}\n\n.group-button2{\n  margin-left: 15px !important;\n}\n\n.toolbar-list-alunos{\n  margin-bottom: 15px;\n}\n\n.marginBottom{\n  margin-bottom: 8px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/statics/css/user-list.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/statics/css/user-list.css
// module chunks = 0